// removed by extract-text-webpack-plugin
module.exports = {"container":"_3OWILhFQGoZJxyP0aC8dsm","current":"_3Ap6FgtAmWW-zzylJsCORT","border":"_3D2kxdxFdJC-R6RVJSN6Pn","label":"_3Dy-TipDUjQq5nNQTdbaXq","palette":"_3pneJYSQZrhckAaDNlaWKz","color":"MSKsgK6hbpa7RUpfL2Cq6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserProfile/components/PersonalColor.mod.css
// module id = 1580
// module chunks = 0